import dayjs from 'dayjs'
import { getStartOfWeek } from './getStartOfWeek'
import type { FirstDayOfWeek } from '../../@types/date'

export function getWeekdaysNames(
    locale: string | undefined,
    firstDayOfWeek: FirstDayOfWeek = 'monday',
    format = 'dd'
) {
    const names = []
    const date = getStartOfWeek(new Date(), firstDayOfWeek)

    for (let i = 0; i < 7; i += 1) {
        const day = dayjs(date)
        const localizedDay = locale ? day.locale(locale) : day

        names.push(localizedDay.format(format))
        date.setDate(date.getDate() + 1)
    }

    return names
}
